/* eslint-disable react/react-in-jsx-scope */
import account_Icon from '../assets/accountIcon.png';
import adBanner_Icon from '../assets/adBannerIcon.png';
import listing_Icon from '../assets/listingIcon.png';
import collectionsIcon from '../assets/collections.png';
import revenue_Icon from '../assets/revenueIcon.png';
import settingIcon from '../assets/settingIcon.png';
import transactionIcon from '../assets/transaction.png';
import usersIcon from '../assets/users.png';
import orderIcon from '../assets/orderIcon.png';
import mediaIcon from '../assets/mediaIcon.png';
import reviewIcon from '../assets/reviewIcon.png';
import reportIcon from '../assets/reportIcon.png';
import channelIcon from '../assets/channelIcon.png';
import moreMenuIcon from '../assets/moreMenuIcon.png';
import webIcon from '../assets/webIcon.png';
import appIcon from '../assets/appIcon.png';
import aiStudioIcon from '../assets/aiStudio.png';
import nativeintegrationIcon from '../assets/nativeintegration.png';
import mobileIcon from '../assets/mobileConfigIcon.png';
import appTranslateIcon from '../assets/appTranslate.png';
import seoIcon from '../assets/seoIcon.png';
import iconGlobal from '../assets/global.png';
import moreIcon from '../assets/moreIcon.png';
import openLinkIcon from '../assets/whiteOpenLinkIcon.png';
import communicationIcon from '../assets/communicationIcon.png';
import deliveryIcon from '../assets/deliveryIcon.png';
import marketplaceIcon from '../assets/marketplaceIcon.png';
import inviteTeamIcon from '../assets/inviteTeamIcon.png';

import branchesIcon from '../assets/branchesIcon.png';
import auditIcon from '../assets/auditIcon.png';
import driver from '../assets/driver.png';
import fleetsIcon from '../assets/fleetsIcon.png';
import rosterIcon from '../assets/rosterIcon.png';
import starIcon from '../assets/starIcon.png';
import giftIcon from '../assets/gift.png';
import home_Icon from '../assets/homeIcon.png'; // Tell webpack this JS file uses this image
import multiCurrencyIcon from './../assets/multiCurrency.png';
import currencyIcon from './../assets/currency.png';
import arrowFromLeft from './../assets/arrow-from-left.png';
import arrowFromRight from './../assets/arrow-from-right.png';
import closeIcon from './../assets/closeIcon.png';
import reportedIcon from './../assets/GroupReport.png';
import help_Icon from '../assets/helpIcon.png';
import documentationIcon from '../assets/documentationIcon.png';
import apiRefIcon from '../assets/apiRefIcon.png';
import communityIcon from '../assets/communityIcon.png';
import menu_Icon from '../assets/menuIcon.png';
import closIcon from '../assets/closeBlackIcon.png';
import calendarIcon from '../assets/calendarIcon.png';
import selectedcalendarIcon from '../assets/selectedcalendarIcon.png';
import notiIcon from '../assets/notificationIcon.png';
import aacountsIcon from '../assets/accounts.png';
import listingsIcon from '../assets/listings.png';
import shippingMethodIcon from '../assets/shippingMethod.png';
import paymentMethodIcon from './../assets/paymentMethod.png';
import commissionsIcon from '../assets/commissions.png';
import subscriptionsIcon from '../assets/subscriptions.png';
import specialFeesIcon from '../assets/specialFees.png';
import languagecon from '../assets/language.png';
import apiIcon from '../assets/api.png';
import infoIcon from '../assets/infoSVGIcon.svg';

export var ICONS = {
  home_Icon,
  account_Icon,
  adBanner_Icon,
  listing_Icon,
  collectionsIcon,
  revenue_Icon,
  settingIcon,
  transactionIcon,
  usersIcon,
  orderIcon,
  mediaIcon,
  reviewIcon,
  reportIcon,
  channelIcon,
  moreMenuIcon,
  webIcon,
  appIcon,
  aiStudioIcon,
  nativeintegrationIcon,
  mobileIcon,
  appTranslateIcon,
  seoIcon,
  iconGlobal,
  moreIcon,
  openLinkIcon,
  communicationIcon,
  deliveryIcon,
  marketplaceIcon,
  branchesIcon,
  auditIcon,
  driver,
  fleetsIcon,
  rosterIcon,
  starIcon,
  giftIcon,
  multiCurrencyIcon,
  currencyIcon,
  arrowFromLeft,
  arrowFromRight,
  closeIcon,
  reportedIcon,
  apiRefIcon,
  communityIcon,
  documentationIcon,
  help_Icon,
  inviteTeamIcon,
  menu_Icon,
  closIcon,
  notiIcon,
  aacountsIcon,
  listingsIcon,
  shippingMethodIcon,
  paymentMethodIcon,
  commissionsIcon,
  subscriptionsIcon,
  specialFeesIcon,
  languagecon,
  apiIcon,
  infoIcon,
  calendarIcon,
  selectedcalendarIcon,
  tradly_logo: (
    <svg
      width="36"
      height="36"
      viewBox="0 0 126 126"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M63 0C97.7939 0 126 28.2061 126 63C126 97.7939 97.7939 126 63 126C28.2061 126 0 97.7939 0 63C0 28.2061 28.2061 0 63 0Z"
        fill="url(#paint0_linear_1500_61)"
      />
      <path
        opacity="0.5"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M63 119C93.9279 119 119 93.9279 119 63C119 32.0721 93.9279 7 63 7C32.0721 7 7 32.0721 7 63C7 93.9279 32.0721 119 63 119Z"
        stroke="white"
        strokeWidth="1.4"
      />
      <g opacity="0.5" filter="url(#filter0_d_1500_61)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M63 105C86.196 105 105 86.4199 105 63.5C105 40.5801 86.196 22 63 22C39.804 22 21 40.5801 21 63.5C21 86.4199 39.804 105 63 105Z"
          stroke="white"
          strokeWidth="1.4"
          shapeRendering="crispEdges"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M63.9842 7C48.329 7 34.1435 13.3548 23.8912 23.6071C18.6743 28.824 14.4654 35.0586 11.5892 41.9949C9.96038 45.9231 11.8244 50.4281 15.7527 52.057C19.681 53.6858 24.1859 51.8218 25.8148 47.8935C27.9054 42.8516 30.9708 38.3064 34.7806 34.4965C40.5365 28.7406 47.9684 24.682 56.2842 23.1155V111.922C56.2842 116.174 59.7316 119.622 63.9842 119.622C68.2368 119.622 71.6842 116.174 71.6842 111.922V23.1155C80 24.682 87.4318 28.7407 93.1877 34.4965L93.1879 34.4968C96.998 38.3065 100.063 42.8515 102.153 47.8931C103.782 51.8215 108.287 53.6858 112.215 52.0571C116.143 50.4285 118.008 45.9236 116.379 41.9953C113.503 35.0588 109.295 28.8241 104.077 23.6071C93.8262 13.3562 79.6431 7.00169 63.9905 7C63.9884 7 63.9863 7 63.9842 7Z"
        fill="white"
      />
      <defs>
        <filter
          id="filter0_d_1500_61"
          x="16.3"
          y="21.3"
          width="93.4001"
          height="92.3999"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1500_61"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_1500_61"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_1500_61"
          x1="0"
          y1="0"
          x2="126"
          y2="126"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#ACF684" />
          <stop offset="0.338542" stopColor="#83EDA2" />
          <stop offset="0.682292" stopColor="#3AD87E" />
          <stop offset="1" stopColor="#13B58C" />
        </linearGradient>
      </defs>
    </svg>
  ),
  search_icon: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth="1.5"
      stroke="currentColor"
      className="size-4">
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z"
      />
    </svg>
  ),
  external_link: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth="1.5"
      stroke="currentColor"
      className="w-4 h-4">
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M13.5 6H5.25A2.25 2.25 0 003 8.25v10.5A2.25 2.25 0 005.25 21h10.5A2.25 2.25 0 0018 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25"
      />
    </svg>
  ),
  left_arrow: (
    <svg
      width="18"
      height="16"
      viewBox="0 0 18 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16.9323 7.30009H3.11311L8.40471 2.20696C8.68179 1.94026 8.69253 1.49716 8.4286 1.21717C8.16503 0.937521 7.72654 0.926321 7.44911 1.19302L1.40593 7.00995C1.14443 7.27454 1 7.62594 1 8.00009C1 8.37388 1.14443 8.72563 1.41805 9.00177L7.44946 14.8068C7.5835 14.936 7.75529 15 7.92708 15C8.10996 15 8.29283 14.9272 8.42895 14.7827C8.69287 14.5027 8.68214 14.0599 8.40505 13.7932L3.09129 8.70008H16.9323C17.3147 8.70008 17.625 8.38648 17.625 8.00009C17.625 7.61369 17.3147 7.30009 16.9323 7.30009Z"
        fill="#01544E"
        stroke="#01544E"
        strokeWidth="0.3"
      />
    </svg>
  ),
  eye: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth="1.5"
      stroke="currentColor"
      className="w-6 h-6">
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z"
      />
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
      />
    </svg>
  ),
  eye_close: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth="1.5"
      stroke="currentColor"
      className="w-6 h-6">
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M3.98 8.223A10.477 10.477 0 0 0 1.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.451 10.451 0 0 1 12 4.5c4.756 0 8.773 3.162 10.065 7.498a10.522 10.522 0 0 1-4.293 5.774M6.228 6.228 3 3m3.228 3.228 3.65 3.65m7.894 7.894L21 21m-3.228-3.228-3.65-3.65m0 0a3 3 0 1 0-4.243-4.243m4.242 4.242L9.88 9.88"
      />
    </svg>
  ),
  copy: (
    <svg
      width="20"
      height="22"
      viewBox="0 0 19 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.5 18H5.5C4.70435 18 3.94129 17.6839 3.37868 17.1213C2.81607 16.5587 2.5 15.7956 2.5 15V5C2.5 4.73478 2.39464 4.48043 2.20711 4.29289C2.01957 4.10536 1.76522 4 1.5 4C1.23478 4 0.98043 4.10536 0.792893 4.29289C0.605357 4.48043 0.5 4.73478 0.5 5V15C0.5 16.3261 1.02678 17.5979 1.96447 18.5355C2.90215 19.4732 4.17392 20 5.5 20H13.5C13.7652 20 14.0196 19.8946 14.2071 19.7071C14.3946 19.5196 14.5 19.2652 14.5 19C14.5 18.7348 14.3946 18.4804 14.2071 18.2929C14.0196 18.1054 13.7652 18 13.5 18ZM18.5 6.94C18.4896 6.84813 18.4695 6.75763 18.44 6.67V6.58C18.3919 6.47718 18.3278 6.38267 18.25 6.3L12.25 0.3C12.1673 0.222216 12.0728 0.158081 11.97 0.11H11.88L11.56 0H7.5C6.70435 0 5.94129 0.316071 5.37868 0.87868C4.81607 1.44129 4.5 2.20435 4.5 3V13C4.5 13.7956 4.81607 14.5587 5.37868 15.1213C5.94129 15.6839 6.70435 16 7.5 16H15.5C16.2956 16 17.0587 15.6839 17.6213 15.1213C18.1839 14.5587 18.5 13.7956 18.5 13V7C18.5 7 18.5 7 18.5 6.94ZM12.5 3.41L15.09 6H13.5C13.2348 6 12.9804 5.89464 12.7929 5.70711C12.6054 5.51957 12.5 5.26522 12.5 5V3.41ZM16.5 13C16.5 13.2652 16.3946 13.5196 16.2071 13.7071C16.0196 13.8946 15.7652 14 15.5 14H7.5C7.23478 14 6.98043 13.8946 6.79289 13.7071C6.60536 13.5196 6.5 13.2652 6.5 13V3C6.5 2.73478 6.60536 2.48043 6.79289 2.29289C6.98043 2.10536 7.23478 2 7.5 2H10.5V5C10.5 5.79565 10.8161 6.55871 11.3787 7.12132C11.9413 7.68393 12.7044 8 13.5 8H16.5V13Z"
        fill="currentColor"
      />
    </svg>
  ),
  plus: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth="1.5"
      stroke="currentColor"
      className="w-6 h-6">
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M12 4.5v15m7.5-7.5h-15"
      />
    </svg>
  ),
  minus: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth="1.5"
      stroke="currentColor"
      className="w-6 h-6">
      <path strokeLinecap="round" strokeLinejoin="round" d="M5 12h14" />
    </svg>
  ),
  close: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth="1.5"
      stroke="currentColor"
      className="w-6 h-6">
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M6 18 18 6M6 6l12 12"
      />
    </svg>
  ),
  hand_burgur: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth="1.5"
      stroke="currentColor"
      className="w-8 h-8">
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"
      />
    </svg>
  ),
  trash_icon: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth="1.5"
      stroke="currentColor"
      className="w-4 h-4">
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0"
      />
    </svg>
  ),
  camera_icon: (
    <svg
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.75033 0.166672L5.76783 2.33334H2.33366C1.14199 2.33334 0.166992 3.30834 0.166992 4.50001V17.5C0.166992 18.6917 1.14199 19.6667 2.33366 19.6667H19.667C20.8587 19.6667 21.8337 18.6917 21.8337 17.5V4.50001C21.8337 3.30834 20.8587 2.33334 19.667 2.33334H16.2328L14.2503 0.166672H7.75033ZM11.0003 16.4167C8.01033 16.4167 5.58366 13.99 5.58366 11C5.58366 8.01001 8.01033 5.58334 11.0003 5.58334C13.9903 5.58334 16.417 8.01001 16.417 11C16.417 13.99 13.9903 16.4167 11.0003 16.4167Z"
        fill="white"
      />
    </svg>
  ),
  close_icon: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth="1.5"
      stroke="currentColor"
      className="w-6 h-6">
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M6 18L18 6M6 6l12 12"
      />
    </svg>
  ),

  edit_icon: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="h-6 w-6   "
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor">
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
      />
    </svg>
  ),
  youtube_icon: (
    <svg
      width="22"
      height="22"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M23 9.71C23.0495 8.27865 22.7365 6.85802 22.09 5.58C21.6514 5.0556 21.0427 4.70171 20.37 4.58C17.5875 4.32752 14.7936 4.22404 12 4.27C9.21667 4.22196 6.43274 4.3221 3.66003 4.57C3.11185 4.66972 2.60454 4.92684 2.20003 5.31C1.30003 6.14 1.20003 7.56 1.10003 8.76C0.954939 10.9176 0.954939 13.0824 1.10003 15.24C1.12896 15.9154 1.22952 16.5858 1.40003 17.24C1.5206 17.7451 1.76455 18.2123 2.11003 18.6C2.51729 19.0035 3.03641 19.2752 3.60003 19.38C5.75594 19.6461 7.92824 19.7564 10.1 19.71C13.6 19.76 16.67 19.71 20.3 19.43C20.8775 19.3316 21.4112 19.0595 21.83 18.65C22.11 18.3699 22.3191 18.0271 22.44 17.65C22.7977 16.5526 22.9733 15.4041 22.96 14.25C23 13.69 23 10.31 23 9.71ZM9.74003 14.85V8.66L15.66 11.77C14 12.69 11.81 13.73 9.74003 14.85Z"
        fill="currentColor"
      />
      <defs>
        <linearGradient
          id="paint0_linear_3700_5604"
          x1="23.0051"
          y1="19.7271"
          x2="23.0051"
          y2="4.25832"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#14B78E" />
          <stop offset="1" stopColor="#2ADABF" />
        </linearGradient>
      </defs>
    </svg>
  ),
  dollar_icon: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14 11H13V7H15C15.2652 7 15.5196 7.10536 15.7071 7.29289C15.8946 7.48043 16 7.73478 16 8C16 8.26522 16.1054 8.51957 16.2929 8.70711C16.4804 8.89464 16.7348 9 17 9C17.2652 9 17.5196 8.89464 17.7071 8.70711C17.8946 8.51957 18 8.26522 18 8C18 7.20435 17.6839 6.44129 17.1213 5.87868C16.5587 5.31607 15.7956 5 15 5H13V3C13 2.73478 12.8946 2.48043 12.7071 2.29289C12.5196 2.10536 12.2652 2 12 2C11.7348 2 11.4804 2.10536 11.2929 2.29289C11.1054 2.48043 11 2.73478 11 3V5H10C8.93913 5 7.92172 5.42143 7.17157 6.17157C6.42143 6.92172 6 7.93913 6 9C6 10.0609 6.42143 11.0783 7.17157 11.8284C7.92172 12.5786 8.93913 13 10 13H11V17H9C8.73478 17 8.48043 16.8946 8.29289 16.7071C8.10536 16.5196 8 16.2652 8 16C8 15.7348 7.89464 15.4804 7.70711 15.2929C7.51957 15.1054 7.26522 15 7 15C6.73478 15 6.48043 15.1054 6.29289 15.2929C6.10536 15.4804 6 15.7348 6 16C6 16.7956 6.31607 17.5587 6.87868 18.1213C7.44129 18.6839 8.20435 19 9 19H11V21C11 21.2652 11.1054 21.5196 11.2929 21.7071C11.4804 21.8946 11.7348 22 12 22C12.2652 22 12.5196 21.8946 12.7071 21.7071C12.8946 21.5196 13 21.2652 13 21V19H14C15.0609 19 16.0783 18.5786 16.8284 17.8284C17.5786 17.0783 18 16.0609 18 15C18 13.9391 17.5786 12.9217 16.8284 12.1716C16.0783 11.4214 15.0609 11 14 11V11ZM11 11H10C9.46957 11 8.96086 10.7893 8.58579 10.4142C8.21071 10.0391 8 9.53043 8 9C8 8.46957 8.21071 7.96086 8.58579 7.58579C8.96086 7.21071 9.46957 7 10 7H11V11ZM14 17H13V13H14C14.5304 13 15.0391 13.2107 15.4142 13.5858C15.7893 13.9609 16 14.4696 16 15C16 15.5304 15.7893 16.0391 15.4142 16.4142C15.0391 16.7893 14.5304 17 14 17Z"
        fill="url(#paint0_linear_3700_5601)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_3700_5601"
          x1="18"
          y1="22"
          x2="18"
          y2="2"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#14B78E" />
          <stop offset="1" stopColor="#2ADABF" />
        </linearGradient>
      </defs>
    </svg>
  ),
  ai_star: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.1071 5.448C9.7051 3.698 12.1231 3.645 12.8321 5.289L12.8921 5.449L13.6991 7.809C13.884 8.35023 14.1829 8.84551 14.5755 9.26142C14.9682 9.67734 15.4454 10.0042 15.9751 10.22L16.1921 10.301L18.5521 11.107C20.3021 11.705 20.3551 14.123 18.7121 14.832L18.5521 14.892L16.1921 15.699C15.6507 15.8838 15.1552 16.1826 14.7391 16.5753C14.323 16.9679 13.996 17.4452 13.7801 17.975L13.6991 18.191L12.8931 20.552C12.2951 22.302 9.8771 22.355 9.1691 20.712L9.1071 20.552L8.3011 18.192C8.11628 17.6506 7.81748 17.1551 7.42485 16.739C7.03221 16.3229 6.5549 15.9959 6.0251 15.78L5.8091 15.699L3.4491 14.893C1.6981 14.295 1.6451 11.877 3.2891 11.169L3.4491 11.107L5.8091 10.301C6.35034 10.1161 6.84562 9.81719 7.26153 9.42457C7.67744 9.03195 8.00432 8.55469 8.2201 8.025L8.3011 7.809L9.1071 5.448ZM11.0001 6.094L10.1941 8.454C9.9125 9.2793 9.45437 10.0333 8.85164 10.6635C8.24891 11.2937 7.51605 11.7849 6.7041 12.103L6.4541 12.194L4.0941 13L6.4541 13.806C7.27941 14.0876 8.03341 14.5457 8.6636 15.1485C9.29379 15.7512 9.78503 16.4841 10.1031 17.296L10.1941 17.546L11.0001 19.906L11.8061 17.546C12.0877 16.7207 12.5458 15.9667 13.1486 15.3365C13.7513 14.7063 14.4842 14.2151 15.2961 13.897L15.5461 13.807L17.9061 13L15.5461 12.194C14.7208 11.9124 13.9668 11.4543 13.3366 10.8515C12.7064 10.2488 12.2152 9.51595 11.8971 8.704L11.8071 8.454L11.0001 6.094ZM19.0001 2C19.1872 2 19.3705 2.05248 19.5293 2.15147C19.688 2.25046 19.8158 2.392 19.8981 2.56L19.9461 2.677L20.2961 3.703L21.3231 4.053C21.5106 4.1167 21.6749 4.23462 21.7953 4.39182C21.9157 4.54902 21.9867 4.73842 21.9994 4.93602C22.012 5.13362 21.9657 5.33053 21.8663 5.50179C21.7669 5.67304 21.6189 5.81094 21.4411 5.898L21.3231 5.946L20.2971 6.296L19.9471 7.323C19.8833 7.51043 19.7653 7.6747 19.608 7.79499C19.4508 7.91529 19.2613 7.98619 19.0637 7.99872C18.8662 8.01125 18.6693 7.96484 18.4981 7.86538C18.3269 7.76591 18.1891 7.61787 18.1021 7.44L18.0541 7.323L17.7041 6.297L16.6771 5.947C16.4896 5.8833 16.3253 5.76538 16.2049 5.60819C16.0845 5.45099 16.0135 5.26158 16.0008 5.06398C15.9882 4.86638 16.0345 4.66947 16.1339 4.49821C16.2333 4.32696 16.3813 4.18906 16.5591 4.102L16.6771 4.054L17.7031 3.704L18.0531 2.677C18.1205 2.47943 18.2481 2.30791 18.4179 2.1865C18.5878 2.06509 18.7913 1.99987 19.0001 2Z"
        fill="url(#paint0_linear_3696_5613)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_3696_5613"
          x1="22.0014"
          y1="21.9056"
          x2="22.0014"
          y2="2"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#14B78E" />
          <stop offset="1" stopColor="#2ADABF" />
        </linearGradient>
      </defs>
    </svg>
  ),
  adjustment_vertical: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth="1.5"
      stroke="currentColor"
      className="h-5 w-5">
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M6 13.5V3.75m0 9.75a1.5 1.5 0 0 1 0 3m0-3a1.5 1.5 0 0 0 0 3m0 3.75V16.5m12-3V3.75m0 9.75a1.5 1.5 0 0 1 0 3m0-3a1.5 1.5 0 0 0 0 3m0 3.75V16.5m-6-9V3.75m0 3.75a1.5 1.5 0 0 1 0 3m0-3a1.5 1.5 0 0 0 0 3m0 9.75V10.5"
      />
    </svg>
  ),
  drag: (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 6 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="nnM_nnN nnQ_nnR nnU_nnV nnY_nnZ noc_noe noh_noi nol_nom nop_noq not_nou TTl_TTm">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1 2a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM5 2a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM1 6a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM5 6a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM1 10a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM5 10a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM1 14a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM5 14a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
        fill="currentColor"></path>
    </svg>
  ),

  zap_icon: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="#01544E"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="lucide lucide-zap h-5 w-5 text-tradly-primary"
      data-lov-id="src/components/products/QuickAddProduct.tsx:90:12"
      data-lov-name="Zap"
      data-component-path="src/components/products/QuickAddProduct.tsx"
      data-component-line="90"
      data-component-file="QuickAddProduct.tsx"
      data-component-name="Zap"
      data-component-content="%7B%22className%22%3A%22h-5%20w-5%20text-tradly-primary%22%7D">
      <path d="M4 14a1 1 0 0 1-.78-1.63l9.9-10.2a.5.5 0 0 1 .86.46l-1.92 6.02A1 1 0 0 0 13 10h7a1 1 0 0 1 .78 1.63l-9.9 10.2a.5.5 0 0 1-.86-.46l1.92-6.02A1 1 0 0 0 11 14z"></path>
    </svg>
  ),
  download_icon: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth="1.5"
      stroke="currentColor"
      className="w-6 h-6">
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5M16.5 12L12 16.5m0 0L7.5 12m4.5 4.5V3"
      />
    </svg>
  ),
  delete_icon: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth="1.5"
      stroke="currentColor"
      className="w-6 h-6">
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0"
      />
    </svg>
  ),
  loading_icon: (
    <svg
      className="animate-spin    h-5 w-5  "
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24">
      <circle
        className="opacity-25"
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        strokeWidth="4"></circle>
      <path
        className="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
    </svg>
  ),
  clock_icon: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth="1.5"
      stroke="currentColor"
      className="w-6 h-6">
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M12 6v6h4.5m4.5 0a9 9 0 11-18 0 9 9 0 0118 0z"
      />
    </svg>
  ),

  chat_gpt_icon: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 720 720"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_1637_2934)">
        <g clipPath="url(#clip1_1637_2934)">
          <path
            d="M304.246 294.611V249.028C304.246 245.189 305.687 242.309 309.044 240.392L400.692 187.612C413.167 180.415 428.042 177.058 443.394 177.058C500.971 177.058 537.44 221.682 537.44 269.182C537.44 272.54 537.44 276.379 536.959 280.218L441.954 224.558C436.197 221.201 430.437 221.201 424.68 224.558L304.246 294.611ZM518.245 472.145V363.224C518.245 356.505 515.364 351.707 509.608 348.349L389.174 278.296L428.519 255.743C431.877 253.826 434.757 253.826 438.115 255.743L529.762 308.523C556.154 323.879 573.905 356.505 573.905 388.171C573.905 424.636 552.315 458.225 518.245 472.141V472.145ZM275.937 376.182L236.592 353.152C233.235 351.235 231.794 348.354 231.794 344.515V238.956C231.794 187.617 271.139 148.749 324.4 148.749C344.555 148.749 363.264 155.468 379.102 167.463L284.578 222.164C278.822 225.521 275.942 230.319 275.942 237.039V376.186L275.937 376.182ZM360.626 425.122L304.246 393.455V326.283L360.626 294.616L417.002 326.283V393.455L360.626 425.122ZM396.852 570.989C376.698 570.989 357.989 564.27 342.151 552.276L436.674 497.574C442.431 494.217 445.311 489.419 445.311 482.699V343.552L485.138 366.582C488.495 368.499 489.936 371.379 489.936 375.219V480.778C489.936 532.117 450.109 570.985 396.852 570.985V570.989ZM283.134 463.99L191.486 411.211C165.094 395.854 147.343 363.229 147.343 331.562C147.343 294.616 169.415 261.509 203.48 247.593V356.991C203.48 363.71 206.361 368.508 212.117 371.866L332.074 441.437L292.729 463.99C289.372 465.907 286.491 465.907 283.134 463.99ZM277.859 542.68C223.639 542.68 183.813 501.895 183.813 451.514C183.813 447.675 184.294 443.836 184.771 439.997L279.295 494.698C285.051 498.056 290.812 498.056 296.568 494.698L417.002 425.127V470.71C417.002 474.549 415.562 477.429 412.204 479.346L320.557 532.126C308.081 539.323 293.206 542.68 277.854 542.68H277.859ZM396.852 599.776C454.911 599.776 503.37 558.513 514.41 503.812C568.149 489.896 602.696 439.515 602.696 388.176C602.696 354.587 588.303 321.962 562.392 298.45C564.791 288.373 566.231 278.296 566.231 268.224C566.231 199.611 510.571 148.267 446.274 148.267C433.322 148.267 420.846 150.184 408.37 154.505C386.775 133.392 357.026 119.958 324.4 119.958C266.342 119.958 217.883 161.22 206.843 215.921C153.104 229.837 118.557 280.218 118.557 331.557C118.557 365.146 132.95 397.771 158.861 421.283C156.462 431.36 155.022 441.437 155.022 451.51C155.022 520.123 210.682 571.466 274.978 571.466C287.931 571.466 300.407 569.549 312.883 565.228C334.473 586.341 364.222 599.776 396.852 599.776Z"
            fill="currentColor"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_1637_2934">
          <rect
            width="720"
            height="720"
            fill="white"
            transform="translate(0.606934 0.0999756)"
          />
        </clipPath>
        <clipPath id="clip1_1637_2934">
          <rect
            width="720"
            height="720"
            fill="white"
            transform="translate(118.557 119.958)"
          />
        </clipPath>
      </defs>
    </svg>
  ),

  app_store_icon: <svg
    className="w-5 h-6 flex-shrink-0 p-0"
    viewBox="0 0 24 24"
    fill="currentColor">
    <path d="M17.05 20.28c-.98.95-2.05.8-3.08.35-1.09-.46-2.09-.48-3.24 0-1.44.62-2.2.44-3.06-.35C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.5-1.31 2.99-2.54 4.09l.01-.01zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z" />
  </svg>,
  play_store_icon: <svg
    className="w-6 h-6 flex-shrink-0"
    viewBox="0 0 24 24"
    fill="currentColor">
    <path d="M3.609 1.814L13.792 12 3.61 22.186a.996.996 0 01-.61-.92V2.734a1 1 0 01.609-.92zm10.89 10.893l2.302 2.302-10.937 6.333 8.635-8.635zm3.199-3.198l2.807 1.626a1 1 0 010 1.73l-2.808 1.626L15.206 12l2.492-2.491zM5.864 2.658L16.8 8.99l-2.302 2.302-8.634-8.634z" />
  </svg>
};
